// Polyfill for 'global' variable in browser environment
// Provides 'global' as an alias for 'window' or 'globalThis' depending on what's available
module.exports = {
  default: typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {}
};

